<template>
  <div class="container-monitor">
     <Modal
      v-model="htmlModal"
      :title="title"
      footer-hide
      width="1400"
      class-name="no-adding-modal">
           <iframe :src="url" style="width:100%;min-height:800px;over-flow:hidden;border: 2px solid #ccc;"></iframe>
      </Modal>
  </div>
</template>
<script>
import Tables from '_c/tables'
export default {
  name: 'NginxMonitor',
  components: {
    Tables
  },
  data () {
    return {
      htmlModal: false,
      url: ''
    }
  },
  methods: {
    cancelModal () {
    },
    show (url) {
      this.url = url
      this.htmlModal = true
    }
  },
  wathch: {
  },
  mounted: function () {
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
  .no-adding-modal .ivu-modal-body {
    padding: 0;
  }
</style>
